import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

// `setting` is { mode: 'LATEST' | 'DEVICE' | 'NONE', deviceId? }; deviceId is
// required for DEVICE and ignored otherwise. Needs RENOLOG_MANAGE — the choice
// is the project's, not the viewer's.
export const patchDashboardGaugeSetting = async (projectId, setting) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `projects/${projectId}/renolog/dashboard-gauges`,
    body: setting,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
